import React from 'react';

export interface YMapsContextType {
    apiKey: string;
    scriptSrc: string;
}

export default React.createContext<YMapsContextType>({scriptSrc: '', apiKey: ''});
